// extracted by mini-css-extract-plugin
export default {"container":"Link_container__dFyXV","link":"Link_link__J-GMu","suffix":"Link_suffix__5XUue"};